/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';

import { createSliceHook, makeActionCreator, createSelector } from '../helpers';
import {
  DXAScoringFormState,
  DXAScoringFormAction,
  DXAScoringFormSuccess,
  DXAScoringFormSelectedScoresAction,
} from './DXAScoringForm.types';
import { addFlagToLumbarSpine } from 'src/scoringForms/utils/dxaScoringFormHelpers';

const initialState: DXAScoringFormState = {
  data: {},
  loading: false,
  selectedScores: [],
};

const { act, actReq, actResolve, actReject, actEmpty } =
  makeActionCreator<DXAScoringFormState>();
export const DXAScoringFormSlice = createSlice({
  name: 'dxaScoringForm',
  initialState,
  selectors: {
    selectData: state => state.data,
  },
  reducers: {
    // TODO(scoring-form-customization): the calculate lifecycle below should
    // follow RANO onto a per-form RPC method — a `d7.dxa.calculate` handler that
    // answers the asking form directly, the way `calculate.onRano` does. No
    // slice is involved: RANO's used to round-trip through Redux and back out on
    // `updateForm`, and that whole path was removed (D7-7889). DXA also owns
    // real UI state here (`selectedScores`, `comment`, and `data` read via
    // `selectData`), which stays put — only the calculate actions go. Tracked
    // separately because DXA is wired into six role modules + DXAReaderPlainForm.
    calculateScores: actReq<DXAScoringFormAction['payload']>(),
    calculateScoresSuccess: act<DXAScoringFormSuccess['payload']>(state => ({
      data: addFlagToLumbarSpine(state),
      loading: false,
    })),
    calculateScoringFailure: actReject(),

    setSelectedScores: act<DXAScoringFormSelectedScoresAction['payload']>(
      (scores, state) => {
        return {
          ...state,
          selectedScores: scores,
        };
      }
    ),
    setComment: act<string | undefined>((comment, state) => {
      return {
        ...state,
        data: {
          ...state.data,
          comment,
        },
      };
    }),

    clearSelectedScores: scoringSlice => ({
      ...scoringSlice,
      selectedScores: [],
    }),
  },
});

export const actions = { ...DXAScoringFormSlice.actions };

export const useDXAScoringFormSlice = createSliceHook(
  DXAScoringFormSlice.name,
  actions
);

// TODO: In the next iteration should be injected separately
export const selectDXAScoringFormState = createSelector('dxaScoringForm');
